<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('staff.queryCondition') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="staffInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="staffInfo.conditions.name" :placeholder="$t('staff.inputStaffName')" clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="staffInfo.conditions.tel" :placeholder="$t('staff.inputPhone')" clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="staffInfo.conditions.staffId" :placeholder="$t('staff.inputStaffId')" clearable>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryStaffMethod">{{ $t('staff.query') }}</el-button>
            <el-button @click="_resetStaffMethod">{{ $t('staff.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('staff.staffManagement') }}</span>
        <el-button type="primary" size="small" class="float-right" @click="_openAddStaffStepPage">
          {{ $t('staff.add') }}
        </el-button>
      </div>

      <el-table :data="staffData" border style="width: 100%">
        <el-table-column prop="userId" :label="$t('staff.staffId')" align="center">
        </el-table-column>
        <el-table-column prop="name" :label="$t('staff.name')" align="center">
        </el-table-column>
        <el-table-column prop="tel" :label="$t('staff.phone')" align="center">
        </el-table-column>
        <el-table-column prop="orgName" :label="$t('staff.relatedOrg')" align="center">
        </el-table-column>
        <el-table-column prop="relCdName" :label="$t('staff.position')" align="center">
        </el-table-column>
        <el-table-column prop="email" :label="$t('staff.email')" align="center">
        </el-table-column>
        <el-table-column prop="address" :label="$t('staff.address')" align="center">
        </el-table-column>
        <el-table-column prop="sex" :label="$t('staff.gender')" align="center">
          <template slot-scope="scope">
            {{ scope.row.sex == 0 ? $t('staff.male') : $t('staff.female') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('staff.operation')" align="center" width="300">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEditStaff(scope.row)">
              {{ $t('staff.edit') }}
            </el-button>
            <el-button size="mini" @click="_resetStaffPwd(scope.row)">
              {{ $t('staff.resetPassword') }}
            </el-button>
            <el-button v-if="scope.row.relCd != 600311000001" size="mini" type="danger"
              @click="openDeleteStaff(scope.row)">
              {{ $t('staff.delete') }}
            </el-button>
            <el-button size="mini" @click="openStaffDetail(scope.row)">
              {{ $t('staff.detail') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="16">
          <div class="tip">
            {{ $t('staff.tip') }}
          </div>
        </el-col>
        <el-col :span="8">
          <el-pagination @current-change="currentPage" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </el-card>

    <!-- REQ20260909006：店铺员工管理（新体系，与骑手端「员工管理」同服务码同表 s_store_staff：
         storeStaff.listStoreStaff 列表 / storeStaff.updateStoreStaff 编辑姓名+角色 / storeStaff.deleteStoreStaff 删除；
         配送员申请/审核体系已随模式B 下线，配送员状态列与审核操作已移除） -->
    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>店铺员工管理</span>
        <el-button size="small" @click="loadDeliveryStaff">刷新</el-button>
      </div>
      <el-table :data="deliveryStaffData" border style="width: 100%">
        <el-table-column prop="staffName" label="员工姓名" align="center">
        </el-table-column>
        <el-table-column prop="tel" label="手机号" align="center">
        </el-table-column>
        <el-table-column label="角色" align="center" width="140">
          <template slot-scope="scope">
            <el-select v-model="scope.row.roleType" size="mini" @change="onRoleChange(scope.row)">
              <el-option label="店长" value="OWNER"></el-option>
              <el-option label="店员" value="STAFF"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- REQ20260909006：配送员状态列随审核体系下线移除（模式B 后无申请/审核过程，字段无实际作用） -->
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="onEditStaff(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.roleType !== 'OWNER'" size="mini" type="danger" @click="onDeleteStaff(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tip" style="margin-top: 12px;">
        本列表为店铺员工管理（REQ20260909006）：「编辑」改姓名；「角色」下拉调整店长/店员；
        「删除」仅对店员开放、操作人须本店店长，删除为软删、该员工将失去本店角色。
        配送员申请/审核体系已随商家自配送模式B 下线（REQ20260909005），存量配送身份仅在小程序员工列表留痕展示。
      </div>
    </el-card>

    <!-- REQ20260909006：新体系员工编辑（改姓名；角色用列表内下拉直接调整）——对齐小程序编辑能力 -->
    <el-dialog title="编辑员工" :visible.sync="editStaffDialogVisible" width="420px" append-to-body>
      <el-form label-width="80px">
        <el-form-item label="员工姓名">
          <el-input v-model="editStaffForm.staffName" maxlength="30" placeholder="请输入员工姓名"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editStaffDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="editStaffSubmitting" @click="submitEditStaff">保存</el-button>
      </div>
    </el-dialog>

    <reset-staff-pwd ref="resetStaffPwd"></reset-staff-pwd>
    <edit-staff ref="editStaff" @success="queryStaff"></edit-staff>
    <delete-staff ref="deleteStaff" @success="queryStaff"></delete-staff>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getStaffList, getOrgsByLevel, listStoreStaff, updateStoreStaff, deleteStoreStaffApply, getStoreId } from '@/api/frame/staffApi'
import ResetStaffPwd from '@/components/frame/resetStaffPwd/resetStaffPwd'
import EditStaff from '@/components/frame/editStaff/editStaff'
import DeleteStaff from '@/components/frame/deleteStaff/deleteStaff'

export default {
  name: 'Staff',
  components: {
    ResetStaffPwd,
    EditStaff,
    DeleteStaff
  },
  data() {
    return {
      staffInfo: {
        moreCondition: false,
        branchOrgs: [],
        departmentOrgs: [],
        relCds: [],
        conditions: {
          branchOrgId: '',
          departmentOrgId: '',
          orgId: '',
          orgName: '',
          orgLevel: '2',
          parentOrgId: '',
          name: '',
          tel: '',
          staffId: '',
          parentOrgName: '',
          parentTwoOrgId: '',
          page: 1,
          rows: 10,
          row:10
        }
      },
      staffData: [],
      // REQ20260908：配送员管理（新体系员工列表，含角色/配送员审核状态）
      deliveryStaffData: [],
      // REQ20260909006：新体系员工编辑弹窗（改姓名）
      editStaffDialogVisible: false,
      editStaffSubmitting: false,
      editStaffForm: {
        storeStaffId: '',
        staffName: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this._initMethod()
    this.loadDeliveryStaff()
  },
  methods: {
    async _initMethod() {
      try {
        const { data } = await getDict('u_org_staff_rel', 'rel_cd')
        this.staffInfo.relCds = data
        this.loadData(1, 10)
        this._getOrgsByOrgLevelStaff(1, 10, 2, '')
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    queryStaff(){
      this.loadData(1,this.pagination.pageSize)
    },
    async loadData(page, rows) {
      this.staffInfo.conditions.page = page
      this.staffInfo.conditions.rows = rows
      this.staffInfo.conditions.row = rows

      try {
        const res = await getStaffList(this.staffInfo.conditions)
        const staffList = res.data
        const relCdsList = this.staffInfo.relCds

        staffList.forEach((staff) => {
          relCdsList.forEach((rel) => {
            if (staff.relCd == rel.statusCd) {
              staff.relCdName = rel.name
            }
          })
        })

        this.staffData = staffList
        this.pagination.total = res.records
        this.pagination.currentPage = page
      } catch (error) {
        console.error('获取员工列表失败:', error)
      }
    },
    currentPage(currentPage) {
      this.loadData(currentPage, 10)
    },
    openEditStaff(staff) {
      this.$refs.editStaff.open(staff)
    },
    openDeleteStaff(staff) {
      this.$refs.deleteStaff.open(staff)
    },
    _moreCondition() {
      console.log(this.staffInfo.moreCondition)
      this.staffInfo.moreCondition = !this.staffInfo.moreCondition
    },
    async _getOrgsByOrgLevelStaff(page, rows, orgLevel, parentOrgId) {
      try {
        const res = await getOrgsByLevel({
          page,
          row: rows,
          orgLevel,
          parentOrgId
        })

        if (orgLevel == 2) {
          this.staffInfo.branchOrgs = res.orgs
        } else {
          this.staffInfo.departmentOrgs = res.orgs
        }
      } catch (error) {
        console.error('获取组织失败:', error)
      }
    },
    _openAddStaffStepPage() {
      this.$router.push('/pages/frame/addStaff')
    },
    _queryStaffMethod() {
      this.loadData(1, 10)
    },
    _resetStaffMethod() {
      this.staffInfo.conditions = {
        ...this.staffInfo.conditions,
        branchOrgId: "",
        orgId: "",
        departmentOrgId: "",
        name: "",
        tel: "",
        staffId: ""
      }
      this.loadData(1, 10)
    },
    _resetStaffPwd(staff) {
      this.$refs.resetStaffPwd.open(staff)
    },
    openStaffDetail(staff) {
      this.$router.push(`/pages/frame/staffDetail?staffId=${staff.userId}`)
    },
    // REQ20260908：配送员管理——新体系员工列表（storeId 为商户 10 开头口径，取自当前店铺上下文）
    async loadDeliveryStaff() {
      const storeId = getStoreId()
      if (!storeId) {
        this.$message.error('未获取到商户信息，请重新登录后再试')
        return
      }
      try {
        const res = await listStoreStaff({ storeId, page: 1, row: 100 })
        this.deliveryStaffData = res.data || []
      } catch (error) {
        console.error('查询员工配送信息失败:', error)
      }
    },
    // 角色调整（店长/店员；与骑手端编辑映射一致：OWNER→adminFlag 'Y'，STAFF→'N'）
    onRoleChange(item) {
      const storeId = getStoreId()
      if (!storeId) {
        this.$message.error('未获取到商户信息，请重新登录后再试')
        this.loadDeliveryStaff()
        return
      }
      const roleText = item.roleType === 'OWNER' ? '店长' : '店员'
      this.$confirm(`确认将「${item.staffName}」的角色调整为${roleText}？`, '提示', { type: 'warning' }).then(async () => {
        try {
          const res = await updateStoreStaff({
            storeStaffId: item.storeStaffId,
            storeId: storeId,
            roleType: item.roleType,
            adminFlag: item.roleType === 'OWNER' ? 'Y' : 'N'
          })
          if (res.code === 0 || res.code === '0') {
            this.$message.success('角色已更新')
            this.loadDeliveryStaff()
          }
        } catch (e) {
          this.loadDeliveryStaff()
        }
      }).catch(() => {
        // 取消时回滚下拉显示
        this.loadDeliveryStaff()
      })
    },
    // 编辑员工（REQ20260909006：改姓名；storeStaff.updateStoreStaff mapper 动态 set 仅非空字段更新，
    // 仅传 staffName 不碰角色/adminFlag；与小程序端「编辑仅姓名」能力对齐）
    onEditStaff(item) {
      this.editStaffForm.storeStaffId = item.storeStaffId || ''
      this.editStaffForm.staffName = item.staffName || ''
      this.editStaffDialogVisible = true
    },
    async submitEditStaff() {
      const storeId = getStoreId()
      if (!storeId) {
        this.$message.error('未获取到商户信息，请重新登录后再试')
        return
      }
      if (!this.editStaffForm.staffName || !this.editStaffForm.staffName.trim()) {
        this.$message.warning('请输入员工姓名')
        return
      }
      this.editStaffSubmitting = true
      try {
        const res = await updateStoreStaff({
          storeStaffId: this.editStaffForm.storeStaffId,
          storeId: storeId,
          staffName: this.editStaffForm.staffName.trim()
        })
        if (res.code === 0 || res.code === '0') {
          this.$message.success('保存成功')
          this.editStaffDialogVisible = false
          this.loadDeliveryStaff()
        }
      } catch (e) { /* 全局错误提示已展示 */ } finally {
        this.editStaffSubmitting = false
      }
    },
    // 删除员工（REQ20260909006：storeStaff.deleteStoreStaff 软删；操作人身份后端取请求头 user-id，
    // 须本店 OWNER，禁删店长/自己；入口显隐已按 roleType!=='OWNER' 控制，后端同口径强校验兜底）
    onDeleteStaff(item) {
      const storeId = getStoreId()
      if (!storeId) {
        this.$message.error('未获取到商户信息，请重新登录后再试')
        return
      }
      this.$confirm(`确认删除员工「${item.staffName}」？删除后该员工将失去本店角色`, '提示', { type: 'warning' }).then(async () => {
        try {
          const res = await deleteStoreStaffApply({
            storeStaffId: item.storeStaffId,
            storeId: storeId
          })
          if (res.code === 0 || res.code === '0') {
            this.$message.success('删除成功')
            this.loadDeliveryStaff()
          }
        } catch (e) { /* 全局错误提示已展示 */ }
      }).catch(() => {})
    }
  },
  watch: {
    'staffInfo.conditions.branchOrgId': {
      handler(val) {
        this._getOrgsByOrgLevelStaff(1, 10, 3, val)
        this.staffInfo.conditions.parentOrgId = val
        this.staffInfo.conditions.departmentOrgId = ''
        this.loadData(1, 10)
      },
      deep: true
    },
    'staffInfo.conditions.departmentOrgId': {
      handler(val) {
        this.staffInfo.conditions.orgId = val
        this.loadData(1, 10)
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.tip {
  color: #999;
  font-size: 12px;
  line-height: 30px;
}

.float-right {
  float: right;
}
</style>